/** Returns the landing page home URL. */
export const getHomeUrl = (): string => {
    return '/'
}

/** Returns the booking calendar URL. */
export const getBookCallUrl = (): string => 'https://cal.com/james-pentalow/30min'
